import type { CanvasModel } from "../core/canvasModel";
import { KarelModel, type KarelModelShape } from "../core/karelModel";
import { KarelView } from "./karelView";

export interface Karel {
  draw(c: CanvasRenderingContext2D): void;
  move(): void;
  turnLeft(): void;
  turnRight(): void;
  turnAround(): void;
  paintCorner(color: string): void;
  putBeeper(): void;
  pickBeeper(): void;
  beepersPresent(): boolean;
  noBeepersPresent(): boolean;
  frontIsClear(): boolean;
  frontIsBlocked(): boolean;
  canMove(direction: string): boolean;
  karelAvenue(): number;
  karelStreet(): number;
  rightIsClear(): boolean;
  rightIsBlocked(): boolean;
  leftIsClear(): boolean;
  leftIsBlocked(): boolean;
  facingNorth(): boolean;
  notFacingNorth(): boolean;
  facingSouth(): boolean;
  notFacingSouth(): boolean;
  facingEast(): boolean;
  notFacingEast(): boolean;
  facingWest(): boolean;
  notFacingWest(): boolean;
  loadWorld(text: string, canvasModel: CanvasModel): void;
  getModel(): KarelModelShape;
}

export function Karel(canvasModel: CanvasModel): Karel {
  const karelModel = KarelModel();

  const that: Karel = {
    draw(c: CanvasRenderingContext2D): void {
      KarelView.draw(canvasModel, karelModel, c);
    },

    move: () => karelModel.move(),
    turnLeft: () => karelModel.turnLeft(),
    turnRight: () => karelModel.turnRight(),
    turnAround: () => karelModel.turnAround(),
    paintCorner: (color: string) => karelModel.paintCorner(color),
    putBeeper: () => karelModel.putBeeper(),
    pickBeeper: () => karelModel.pickBeeper(),

    beepersPresent: () => karelModel.beeperPresent(),
    noBeepersPresent: () => !karelModel.beeperPresent(),

    frontIsClear: () => karelModel.frontIsClear(),
    frontIsBlocked: () => !karelModel.frontIsClear(),

    canMove: (direction: string) => karelModel.canMove(direction),
    karelAvenue: () => karelModel.getKarelCol() + 1,
    karelStreet: () => karelModel.getNumRows() - karelModel.getKarelRow(),

    rightIsClear: () => karelModel.rightIsClear(),
    rightIsBlocked: () => !karelModel.rightIsClear(),
    leftIsClear: () => karelModel.leftIsClear(),
    leftIsBlocked: () => !karelModel.leftIsClear(),

    facingNorth: () => karelModel.facingNorth(),
    notFacingNorth: () => !karelModel.facingNorth(),
    facingSouth: () => karelModel.facingSouth(),
    notFacingSouth: () => !karelModel.facingSouth(),
    facingEast: () => karelModel.facingEast(),
    notFacingEast: () => !karelModel.facingEast(),
    facingWest: () => karelModel.facingWest(),
    notFacingWest: () => !karelModel.facingWest(),

    loadWorld(text: string, model: CanvasModel): void {
      karelModel.loadWorld(text, model);
    },

    getModel: () => karelModel,
  };

  return that;
}
